<template lang="pug">
.card
    .card-content
        .media
            .media-left
                figure.image.is-48x48
                    img(src="@/assets/symbols/sportscourt.png")
            .media-content
                p.title.is-5.has-text-weight-medium Next Game
                p.subtitle.is-6.has-text-weight-light Countdown to Craziness
                p.subtitle.is-6.has-text-weight-light 10/20/20 @ 7 pm
</template>

<script>
export default {
  name: "NextGame"
};
</script>
